var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-box"},[_c('div',{attrs:{"id":"container"}}),_c('i',{staticClass:"icon iconfont icon-fh",on:{"click":_vm.goBack}})])
}
var staticRenderFns = []

export { render, staticRenderFns }